import { VariaveisAmbiente } from 'config';
import { useCallback } from 'react';
import { useApiBase } from '../../base/api-base';
import { PessoaParametroRequestModel } from 'model/api/gestao/pessoa/pessoa-parametro-request-model';

export function usePostPessoaParametro() {
  const { invocarApi, ...outrasPropriedades } = useApiBase();

  const postPessoaParametro = useCallback(
    (model: PessoaParametroRequestModel) =>
      invocarApi({
        method: 'POST',
        url: `/${VariaveisAmbiente.apiVersion}/pessoa/${model.pessoaId}/parametro`,
        data: model,
        enviarTokenUsuario: true,
      }),
    [invocarApi],
  );
  return {
    ...outrasPropriedades,
    postPessoaParametro,
  };
}
